import React from "react"
import ReactDOM from "react-dom/client"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { Toaster } from "@/components/ui/toaster"
import App from "./App"
import { EthersProvider } from "./providers/EthersProvider"
import { AuxEthersProvider } from "./providers/AuxEthersProvider"
import { ThemeProvider } from "@/components/theme-provider"
import { TooltipProvider } from "@/components/ui/tooltip"
import { ErrorBoundary } from "@/components/ErrorBoundary"
import "./index.css"

const queryClient = new QueryClient()

function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="welephant-ui-theme">
      <TooltipProvider>
        <QueryClientProvider client={queryClient}>
          <EthersProvider>
            <AuxEthersProvider>
              {children}
            </AuxEthersProvider>
          </EthersProvider>
        </QueryClientProvider>
      </TooltipProvider>
    </ThemeProvider>
  )
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <Providers>
        <App />
        <Toaster />
      </Providers>
    </ErrorBoundary>
  </React.StrictMode>
)
